<template>
  <div class="hzc-price-index">
    <div class="back">当前位置：<span @click="back('/coke')">焦炭</span> > <span
        @click="back('/coke/twoPage/cokeYield')">产量</span> > 正文
    </div>
    <DetailTitle style="margin-bottom: 20px;" :title="$route.query.id+'焦炭产量分省 '"></DetailTitle>
    <div>
      <el-table
          :data="tableData"
          :header-cell-style="{background:'#f2f2f2',color:'#222'}"
          height="600"
          border
          style="width: 100%">
        <el-table-column
            align="center"
            prop="provinceName"
            label="省份">
        </el-table-column>
        <el-table-column
            align="center"
            prop="price1"
            label="当月（万吨）">
        </el-table-column>
        <el-table-column
            align="center"
            prop="price2"
            label="当月同比（%）">
        </el-table-column>
        <el-table-column
            align="center"
            prop="price3"
            label="累计（万吨）">
        </el-table-column>
        <el-table-column
            align="center"
            prop="price4"
            label="累计同比（%）">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import DetailTitle from '@/components/common/detatilTitle'
import {cokeYieldDetail} from "@/api/steel";

export default {
  name: "priceIndex",
  components: {
    DetailTitle,
  },
  data() {
    return {
      num:1,
      time:'',
      flag:'',
      tableData: [],
    }
  },
  created() {
    this.flag = this.$route.query.flag;
    this.time = this.$route.query.id;
    this.getList()
  },
  methods:{
    /**
     * 获取列表
     */
    getList() {
      cokeYieldDetail({endTime:this.$route.query.id}).then(res => {
        this.tableData = res.data;
      })
    },
    /**
     * 返回
     * @param url
     */
    back(url) {
      this.$router.push({path:url, query:{flag:this.flag}});
    },
  }
}
</script>

<style scoped lang="less">
.active {
  background-color: #D3131A !important;
  color:#FFF;
  border:none !important;
}
.hzc-price-index {
  width: 1200px;
  margin: 0 auto;

  .tabs {
    margin: 15px 0;

    div {
      display: inline-block;
      margin-right: 16px;
      padding:0 10px;
      height: 36px;
      background: #F2F2F2;
      border-radius: 4px;
      border: 1px solid #CCCCCC;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }

    div:hover {
      background-color: #D3131A;
      color: #fff;
    }
  }
}
.back {
  span {
    cursor: pointer;
  }
}
</style>
